// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3QiVw","modalForm":"UpgradeEpcsModal_modalForm__2Ssyl","modalFooter":"UpgradeEpcsModal_modalFooter__jY6QH"};